// Harness Personalization Module

function initHarnessModule() {

  const harnessModule = {

    sizes: {
      Sunshine: [
        { label: 'XS - 11-14"',     variantId: '52713034318099' },
        { label: 'S - 14-16"',      variantId: '52713034350867' },
        { label: 'M - 16-19"',      variantId: '52713034383635' },
        { label: 'L - 19.5-23.5"',  variantId: '52713034416403' },
        { label: 'XL - 23.5-26"',   variantId: '52713034449171' }
      ],
      Sunrise: [
        { label: 'XS - 11-14"',     variantId: '52713034154259' },
        { label: 'S - 14-16"',      variantId: '52713034187027' },
        { label: 'M - 16-19"',      variantId: '52713034219795' },
        { label: 'L - 19.5-23.5"',  variantId: '52713034252563' },
        { label: 'XL - 23.5-26"',   variantId: '52713034285331' }
      ]
    },

    upsells: {
      'waste-bag': {
        name: 'Waste Bag Holder',
        price: 12,
        variants: { Sunshine: '52713110733075', Sunrise: '52713110765843' }
      },
      leash: {
        name: 'Braided Cotton Leash 5ft',
        price: 35,
        variants: {
          Sand: '47176852570387', Pink: '47176852898067',
          'Hot Pink': '47176852930835', Khaki: '47176852963603',
          Red: '47977264054547', Turquoise: '47176853029139',
          Navy: '52817026482451', Black: '54213926093075'
        }
      }
    },

    leashClassMap: {
      'Sand': 'sand', 'Pink': 'pink', 'Hot Pink': 'hot-pink',
      'Khaki': 'khaki', 'Red': 'red', 'Turquoise': 'turquoise',
      'Navy': 'navy', 'Black': 'black'
    },

    // Carousel image filenames per colorway
    carouselImages: {
      Sunshine: [
        'paws-paws-miami-custom-dog-harness-sunshine.png',
        'paws-paws-miami-custom-dog-harness-sunshine-step-in.png',
        'paws-paws-miami-custom-dog-harness-sunshine-no-choke.png',
        'paws-paws-miami-custom-dog-harness-sunshine-lifestyle-daisy.png'
      ],
      Sunrise: [
        'paws-paws-miami-custom-dog-harness-sunrise.png',
        'paws-paws-miami-sunrise-floral-step-in-dog-harness-back.png',
        'paws-paws-miami-custom-dog-harness-sunrise-no-choke.png',
        'paws-paws-miami-custom-dog-harness-sunrise-step-in.png',
        'paws-paws-miami-custom-dog-harness-sunrise-lifestyle-coco.png'
      ]
    },

    // Specific hero filename per colorway for carousel jump
    heroImages: {
      Sunshine: 'paws-paws-miami-custom-dog-harness-sunshine.png',
      Sunrise:  'paws-paws-miami-custom-dog-harness-sunrise.png'
    },

    selectedColorway: 'Sunshine',
    selectedSize: null,
    selectedSizeVariantId: null,
    upsellSelections: {},
    userHasSelected: false,
    isReady: false,

    init() {
      const mediaConfig = document.getElementById('harness-media-config');
      this.mediaConfig = mediaConfig ? JSON.parse(mediaConfig.textContent) : null;
      this.cacheElements();
      this.refinedAccessories = !!document.querySelector('[data-harness-refinement]');
      this.bindEvents();
      if (this.mediaConfig) {
        this.selectedColorway = this.mediaConfig.initialColor === 'Bright Floral' ? 'Sunrise' : 'Sunshine';
        this.$swatches.forEach(s => s.classList.toggle('selected', s.dataset.colorway === this.selectedColorway));
        this.$colorwayInput.value = this.mediaConfig.initialColor;
        const selected = this.mediaConfig.variants.find(v => String(v.id) === String(this.mediaConfig.selectedVariantId));
        const size = selected && this.sizes[this.selectedColorway].find(s => String(s.variantId) === String(selected.id));
        if (size) {
          this.selectedSize = size.label;
          this.selectedSizeVariantId = size.variantId;
          this.$sizeInput.value = size.label;
        }
      }
      this.populateSizePills(this.selectedColorway);
      if (this.mediaConfig) this.updateCarousel(this.selectedColorway);
      if (this.refinedAccessories) {
        this.initRefinedAccessories();
        this.updateColorwayLabel();
      } else {
        this.fetchLeashAvailability();
      }
      const run = () => {
        if (!this.userHasSelected) {
          if (!this.mediaConfig) this.updateCarousel(this.selectedColorway);
          this.updateWasteBagImage(this.selectedColorway);
        }
      };
      if (document.readyState === 'complete') {
        run();
      } else {
        window.addEventListener('load', run);
      }
      this.isReady = true;
    },

    fetchLeashAvailability() {
      fetch('/products/braided-cotton-leash.js')
        .then(r => r.json())
        .then(product => {
          const dropdown = document.querySelector('.harness-upsell-dropdown[data-upsell-id="leash"]');
          if (!dropdown) return;

          product.variants.forEach(variant => {
            const option = dropdown.querySelector(`option[data-variant-id="${variant.id}"]`);
            if (!option) return;
            if (!variant.available) {
              option.remove();
            }
          });
        })
        .catch(err => console.error('Leash availability check failed:', err));
    },

    cacheElements() {
      this.$swatches      = document.querySelectorAll('.harness-swatch');
      this.$sizePills     = document.querySelector('.harness-size-pills');
      this.$colorwayInput = document.querySelector('.harness-colorway-input');
      this.$sizeInput     = document.querySelector('.harness-size-input');
      this.$dropdowns     = document.querySelectorAll('.harness-upsell-dropdown');
      this.$atcButton     = document.getElementById('harness-add-to-cart');
    },

    bindEvents() {
      this.$swatches.forEach(swatch => {
        swatch.addEventListener('click', (e) => {
          e.preventDefault();
          this.selectColorway(swatch);
        });
      });

      // Waste bag checkbox
      const wasteBagCheckbox = document.querySelector('.harness-upsell-checkbox[data-upsell-id="waste-bag"]');
      if (wasteBagCheckbox) {
        wasteBagCheckbox.addEventListener('change', () => {
          this.updateWasteBagSelection();
        });
      }

      // Leash dropdown
      const leashDropdown = document.querySelector('.harness-upsell-dropdown[data-upsell-id="leash"]');
      if (leashDropdown) {
        leashDropdown.addEventListener('change', (e) => {
          this.updateUpsellSelection(e.target);
          this.updateUpsellImage(e.target);
        });
      }

           if (this.$atcButton) {
        this.$atcButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.addToCart();
        });
      }
    },

    selectColorway(swatchEl) {
      const colorway = swatchEl.dataset.colorway;
      this.userHasSelected = true;
      this.$swatches.forEach(s => s.classList.remove('selected'));
      swatchEl.classList.add('selected');

      this.selectedColorway = colorway;
      this.$colorwayInput.value = colorway;
      if (this.refinedAccessories) this.updateColorwayLabel();

      const retainedSize = this.mediaConfig && this.sizes[colorway].find(size => size.label === this.selectedSize);
      this.selectedSize = retainedSize ? retainedSize.label : null;
      this.selectedSizeVariantId = retainedSize ? retainedSize.variantId : null;
      this.$sizeInput.value = retainedSize ? retainedSize.label : '';

      this.populateSizePills(colorway);
      this.updateCarousel(colorway);
      this.updateWasteBagImage(colorway);
      this.updateWasteBagSelection();
      this.jumpToFirstSlide(colorway);
    },

    // Click the thumbnail matching the hero image to jump carousel to correct slide
    jumpToFirstSlide(colorway) {
      if (this.mediaConfig) return;
      const heroFile = this.heroImages[colorway];
      const allSlides = document.querySelectorAll('.slider__slide');

      for (const slide of allSlides) {
        if (!slide.id.includes('Thumbnails-')) continue;

        const img = slide.querySelector('img');
        if (!img) continue;

        const src = img.getAttribute('srcset') || img.getAttribute('src') || '';
        if (src.includes(heroFile)) {
          const btn = slide.querySelector('button') || slide;
          btn.click();
          break;
        }
      }
    },

    // Filter carousel slides by matching image filenames
    updateCarousel(colorway) {
      if (this.mediaConfig) {
        this.updateHarnessGallery(colorway);
        return;
      }
      const targetFiles = this.carouselImages[colorway];
      const allFiles    = [
        ...this.carouselImages.Sunshine,
        ...this.carouselImages.Sunrise
      ];

      // All slides and thumbs share .slider__slide class in Ride theme
      const allSlides = document.querySelectorAll('.slider__slide');
      const slides = [];
      const thumbs = [];

      allSlides.forEach(slide => {
        if (slide.id && slide.id.includes('Thumbnails-')) {
          thumbs.push(slide);
        } else {
          slides.push(slide);
        }
      });

      [...slides, ...thumbs].forEach(slide => {
        const img = slide.querySelector('img');
        if (!img) return;

        // Check src and srcset for filename
        const src = img.getAttribute('src') || '';
        const srcset = img.getAttribute('srcset') || '';
        const combined = src + srcset;

        const isColorwayImage = allFiles.some(f => combined.includes(f));

        if (!isColorwayImage) {
          slide.style.display = '';
          return;
        }

        const isSelected = targetFiles.some(f => combined.includes(f));
        slide.style.display = isSelected ? '' : 'none';
      });
    },

    updateHarnessGallery(colorway) {
      const gallery = document.getElementById(`MediaGallery-${this.mediaConfig.sectionId}`);
      if (!gallery) return;
      const ids = this.mediaConfig.galleries[colorway];
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      const thumbnails = gallery.querySelector('[id^="GalleryThumbnails-"]');
      const slides = Array.from(viewer.querySelectorAll('.product__media-item[data-media-id]'));
      const thumbs = thumbnails ? Array.from(thumbnails.querySelectorAll('[data-target]')) : [];
      const mediaId = element => (element.dataset.mediaId || element.dataset.target).split('-').pop();
      for (const elements of [slides, thumbs]) {
        elements.forEach(element => {
          element.style.display = ids.includes(mediaId(element)) ? '' : 'none';
          element.classList.remove('is-active');
        });
        ids.forEach((id, index) => {
          const element = elements.find(element => mediaId(element) === id);
          if (!element) return;
          element.parentElement.appendChild(element);
          if (element.dataset.target) element.dataset.mediaPosition = String(index + 1);
        });
      }
      const firstSlide = slides.find(slide => mediaId(slide) === ids[0]);
      firstSlide?.classList.add('is-active');
      for (const slider of [viewer, thumbnails]) {
        if (!slider) continue;
        slider.querySelector('[id^="Slider-"]')?.scrollTo({ left: 0, behavior: 'instant' });
        slider.resetPages?.();
      }
      gallery.setActiveMedia?.(`${this.mediaConfig.sectionId}-${ids[0]}`, false);
      const modal = document.getElementById(`ProductModal-${this.mediaConfig.sectionId}`);
      const modalMedia = modal ? Array.from(modal.querySelectorAll('[data-media-id]')) : [];
      modalMedia.forEach(element => { element.style.display = ids.includes(mediaId(element)) ? '' : 'none'; });
      ids.forEach(id => {
        const element = modalMedia.find(element => mediaId(element) === id);
        if (element) element.parentElement.appendChild(element);
      });
      gallery.setAttribute('data-harness-ready', '');
    },

    populateSizePills(colorway) {
      const sizes = this.sizes[colorway];
      this.$sizePills.innerHTML = '';

      sizes.forEach(size => {
        const pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'harness-size-pill';
        pill.textContent = size.label;
        pill.dataset.variantId = size.variantId;
        if (this.mediaConfig) {
          const variant = this.mediaConfig.variants.find(v => String(v.id) === size.variantId);
          pill.disabled = !variant?.available;
          pill.classList.toggle('selected', size.label === this.selectedSize);
        }

        pill.addEventListener('click', (e) => {
          e.preventDefault();
          this.selectSize(pill, size);
        });

        this.$sizePills.appendChild(pill);
      });
    },

    selectSize(pillEl, sizeObj) {
      document.querySelectorAll('.harness-size-pill').forEach(p => p.classList.remove('selected'));
      pillEl.classList.add('selected');

      this.selectedSize = sizeObj.label;
      this.selectedSizeVariantId = sizeObj.variantId;
      this.$sizeInput.value = this.selectedSize;
      const installmentVariant = document.querySelector('#harness-installments [name="id"]');
      if (installmentVariant) {
        installmentVariant.value = this.selectedSizeVariantId;
        installmentVariant.dispatchEvent(new Event('change', { bubbles: true }));
      }
    },

    // Waste bag image toggles with colorway
    updateWasteBagImage(colorway) {
      if (this.refinedAccessories) {
        if (!this.pouchManuallySelected) this.matchPouchColor();
        return;
      }
      const sunshineImg = document.querySelector('.harness-upsell-img-sunshine');
      const sunriseImg  = document.querySelector('.harness-upsell-img-sunrise');

      if (sunshineImg) sunshineImg.style.setProperty('display', colorway === 'Sunshine' ? 'block' : 'none', 'important');
      if (sunriseImg)  sunriseImg.style.setProperty('display', colorway === 'Sunrise' ? 'block' : 'none', 'important');
    },

    // Waste bag checkbox — auto-match colorway variant
    updateWasteBagSelection() {
      if (this.refinedAccessories) {
        this.syncAccessory('waste-bag');
        return;
      }
      const checkbox = document.querySelector('.harness-upsell-checkbox[data-upsell-id="waste-bag"]');
      if (!checkbox) return;

      if (checkbox.checked) {
        const variantId = this.upsells['waste-bag'].variants[this.selectedColorway];
        this.upsellSelections['waste-bag'] = {
          variantId: variantId,
          label: this.selectedColorway
        };
      } else {
        delete this.upsellSelections['waste-bag'];
      }
    },
    updateColorwayLabel() {
      const label = document.querySelector('.harness-selected-colorway');
      const color = this.selectedColorway === 'Sunshine' ? 'Pastel Floral' : 'Bright Floral';
      if (label) label.textContent = color;
      this.$colorwayInput.value = color;
    },

    initRefinedAccessories() {
      this.accessoryButtons = {};
      document.querySelectorAll('[data-harness-refinement] [data-accessory]').forEach(card => {
        const key = card.dataset.accessory;
        const buttons = Array.from(card.querySelectorAll('.harness-accessory-option'));
        buttons.forEach(button => button.addEventListener('click', () => {
          if (key === 'waste-bag') this.pouchManuallySelected = true;
          this.selectAccessory(key, button);
        }));
        if (key === 'leash') {
          card.querySelector('input[type="checkbox"]').addEventListener('change', () => this.syncAccessory(key));
          this.selectAccessory(key, buttons.find(button => button.dataset.color === 'Sand') || buttons[0]);
        }
      });
      this.matchPouchColor();
    },

    matchPouchColor() {
      const card = document.querySelector('[data-harness-refinement] [data-accessory="waste-bag"]');
      const id = this.upsells['waste-bag'].variants[this.selectedColorway];
      const button = card?.querySelector(`[data-variant-id="${id}"]`);
      if (button) this.selectAccessory('waste-bag', button);
    },

    selectAccessory(key, button) {
      if (!button) return;
      const card = button.closest('[data-accessory]');
      this.accessoryButtons[key] = button;
      card.querySelectorAll('.harness-accessory-option').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
      card.querySelector('.harness-accessory-color').textContent = button.dataset.color;
      card.querySelector('.harness-accessory-price').textContent = button.dataset.money;
      const image = card.querySelector('.harness-accessory-image');
      image.src = button.dataset.image;
      image.alt = key === 'leash' ? 'Leash — ' + button.dataset.color : 'Waste Bag Holder — ' + button.dataset.color;
      const status = card.querySelector('.harness-accessory-status');
      status.hidden = !button.disabled;
      status.textContent = button.disabled ? card.dataset.unavailable : '';
      this.syncAccessory(key);
    },

    syncAccessory(key) {
      const card = document.querySelector(`[data-harness-refinement] [data-accessory="${key}"]`);
      const checkbox = card?.querySelector('input[type="checkbox"]');
      const button = this.accessoryButtons?.[key];
      if (!card || !checkbox) return;
      card.querySelector('.harness-accessory-fields').hidden = !checkbox.checked;
      if (checkbox.checked && button) {
        this.upsellSelections[key] = { variantId: button.dataset.variantId, label: button.dataset.color };
      } else {
        delete this.upsellSelections[key];
      }
    },

    async verifyAccessories() {
      for (const key of Object.keys(this.upsellSelections)) {
        const card = document.querySelector(`[data-harness-refinement] [data-accessory="${key}"]`);
        if (!card) continue;
        let product;
        try {
          const response = await fetch(card.dataset.url + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (!response.ok) throw new Error();
          product = await response.json();
        } catch (_) {
          throw new Error(card.dataset.verifyError);
        }
        const selected = this.accessoryButtons[key];
        const variant = product.variants?.find(variant => String(variant.id) === selected?.dataset.variantId);
        if (!variant?.available || selected.disabled) {
          if (selected) selected.disabled = true;
          const status = card.querySelector('.harness-accessory-status');
          status.textContent = card.dataset.unavailable;
          status.hidden = false;
          throw new Error(card.dataset.unavailable);
        }
      }
    },

    updateUpsellImage(dropdown) {
      if (dropdown.dataset.upsellId !== 'leash') return;

      const selectedValue = dropdown.value;
      const classSuffix   = this.leashClassMap[selectedValue];

      Object.values(this.leashClassMap).forEach(suffix => {
        const img = document.querySelector(`.harness-upsell-img-${suffix}`);
        if (img) img.style.display = 'none';
      });

      if (classSuffix) {
        const img = document.querySelector(`.harness-upsell-img-${classSuffix}`);
        if (img) img.style.display = 'block';
      }
    },

    updateUpsellSelection(dropdown) {
      const upsellId      = dropdown.dataset.upsellId;
      const selectedValue = dropdown.value;
      const selectedOption = dropdown.options[dropdown.selectedIndex];

      if (selectedValue) {
        this.upsellSelections[upsellId] = {
          variantId: selectedOption.dataset.variantId,
          label: selectedValue
        };
      } else {
        delete this.upsellSelections[upsellId];
      }
    },

    getCartLineItems() {
      const lineItems = [];

      if (this.selectedSizeVariantId) {
        lineItems.push({
          id: parseInt(this.selectedSizeVariantId),
          quantity: 1,
          properties: {
            Colorway: this.mediaConfig ? (this.selectedColorway === 'Sunshine' ? 'Pastel Floral' : 'Bright Floral') : this.selectedColorway,
            'Chest Size': this.selectedSize
          }
        });
      }

      Object.values(this.upsellSelections).forEach(upsell => {
        if (upsell.variantId) {
          lineItems.push({
            id: parseInt(upsell.variantId),
            quantity: 1,
            properties: {
              upsell_source: 'harness_module',
              parent_product: 'Miami Muse Step-in Harness'
            }
          });
        }
      });

      return lineItems;
    },

    validateForm() {
      if (!this.selectedColorway) {
        alert('Please select a colorway.');
        return false;
      }
      if (!this.selectedSize) {
        alert('Please select a chest size.');
        return false;
      }
      return true;
    },

    addToCart() {
      if (!this.isReady || this.adding) return;
      if (!this.validateForm()) return;
      this.adding = true;

      const items = this.getCartLineItems();
      const btn   = this.$atcButton;
      btn.disabled    = true;
      btn.textContent = 'Adding...';

      const verification = this.refinedAccessories ? this.verifyAccessories() : Promise.resolve();
      verification.then(() => fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      }))
      .then(r => {
        if (!r.ok) {
          return r.json().then(err => {
            throw new Error(err.description || 'Cart error ' + r.status);
          });
        }
        return r.json();
      })
      .then(() => { window.location.href = '/cart'; })
      .catch(err => {
        console.error('Cart error:', err);
        alert('Error: ' + err.message);
        this.adding = false;
        btn.disabled    = false;
        btn.textContent = '✨ ADD TO CART';
      });
    }
  };

  harnessModule.init();
  window.harnessModule = harnessModule;
}

// Safe init — works whether script loads before or after DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHarnessModule);
} else {
  initHarnessModule();
}

